import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import useOAuthForReminder from "src/welcome/data-access/useOAuthForReminder";

export default function OauthHandlerForReminder() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const mode = searchParams.get("mode");
  const oAuthToken = searchParams.get("oauth_token");
  const oAuthVerifier = searchParams.get("oauth_verifier");

  const { data, error } = useOAuthForReminder(mode, oAuthToken, oAuthVerifier);

  return (
    <Box>
      <Typography variant="body1">
        {t("Περιμένετε να γίνει η διασταύρωση των στοιχείων...")}
      </Typography>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}
